/**
 * @generated SignedSource<<50c5a3e69b0b68c87cde48640acaeb1c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type walletUploader_PresignQuery$variables = {
  fileExtension: string;
  nonce: string;
};
export type walletUploader_PresignQuery$data = {
  readonly uploadPresign: {
    readonly signedUrl: string;
    readonly storageKey: string;
  } | null | undefined;
};
export type walletUploader_PresignQuery = {
  response: walletUploader_PresignQuery$data;
  variables: walletUploader_PresignQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fileExtension"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nonce"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "fileExtension",
    "variableName": "fileExtension"
  },
  {
    "kind": "Variable",
    "name": "nonce",
    "variableName": "nonce"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "storageKey",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "walletUploader_PresignQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UploadPresign",
        "kind": "LinkedField",
        "name": "uploadPresign",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "walletUploader_PresignQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UploadPresign",
        "kind": "LinkedField",
        "name": "uploadPresign",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "126dbf7e1d52a7ec472157dc2bd68ab1",
    "id": null,
    "metadata": {},
    "name": "walletUploader_PresignQuery",
    "operationKind": "query",
    "text": "query walletUploader_PresignQuery(\n  $fileExtension: String!\n  $nonce: String!\n) {\n  uploadPresign(fileExtension: $fileExtension, nonce: $nonce) {\n    signedUrl\n    storageKey\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d4a9c25875b8e9117aa0ba9bc86bfffa";

export default node;
